// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2hq5l","colMaxWidth":"Table_colMaxWidth__qEISL"};